import { CSSObject } from '@emotion/react';

export const CarouselWrapper: CSSObject = {
  '& .carousel .slider-wrapper ': {
    w: ['99%', null, 'full'],
    mt: ['8', null, '0'],
  },
};
